import { combinedApi as api } from "../combinedApi";
export const addTagTypes = ["Threshold"] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getThresholdGetStandards: build.query<
        GetThresholdGetStandardsApiResponse,
        GetThresholdGetStandardsApiArg
      >({
        query: () => ({ url: `/Threshold/GetStandards` }),
        providesTags: ["Threshold"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as thresholdApi };
export type GetThresholdGetStandardsApiResponse = /** status 200 OK */ string[];
export type GetThresholdGetStandardsApiArg = void;
export const {
  useGetThresholdGetStandardsQuery,
  useLazyGetThresholdGetStandardsQuery,
} = injectedRtkApi;
